module.exports = __webpack_public_path__ + "static/media/inside-red-tank.d8e679c2.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./media/photos/inside-red-tank.jpg
 ** module id = 297
 ** module chunks = 0
 **/